import { TTF } from '@/constants/queryParams';
import useAuth from '@/hooks/useAuth';
import { useSearchParams } from '@/hooks/useSearchParams';
import { useListCalendarEvents } from '@/queries/calendar-event.queries';
import { useGetCalendarQuery } from '@/queries/calendar.queries';
import { Temporal } from 'temporal-polyfill';

export const VISIBLE_DAYS = 5;

export function useBookingPlannerController() {
	const auth = useAuth();
	const params = useSearchParams();
	const from = params.get(TTF) || Temporal.Now.plainDateISO().toString();
	const calendarIds = params.get('ids');
	// TODO: In the future we need to allow multiple calendars
	const calendarId = calendarIds?.split(',')[0] as string;
	const calendarQuery = useGetCalendarQuery({ id: calendarId });

	if (!calendarIds) {
		throw Error('Missing calendar IDs');
	}

	const fromDate = Temporal.PlainDate.from(from).toZonedDateTime({ timeZone: auth.getCurrentUser().timeZone });
	const timeMin = fromDate.with({ hour: 0, minute: 0, second: 0, millisecond: 0 }).toInstant().toString();
	const timeMax = fromDate
		// As usual there is some fucking bug so we add one day for safety
		.add({ days: VISIBLE_DAYS + 1 })
		.with({ hour: 0, minute: 0, second: 0, millisecond: 0 })
		.toInstant()
		.toString();

	const calendarEventsQuery = useListCalendarEvents({
		calendarIds: calendarIds,
		includeEventsWithoutInterval: true,
		timeMin,
		timeMax,
	});

	return {
		calendarEventsQuery,
		calendarQuery,
	};
}
